import { getCookie, setCookie } from '@atlassian/browser-storage-controls/cookie-controls';
export var SINGLE_INSTRUMENTATION_ID_IS_NOT_SET = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
export var getSingleInstrumentationIDCookieName = function getSingleInstrumentationIDCookieName(uniqueCookieFeatureName) {
  return "AI_INSTRUMENTATION_FEATURE_ID_".concat(uniqueCookieFeatureName);
};
export var setSingleInstrumentationIDCookie = function setSingleInstrumentationIDCookie(uniqueCookieFeatureName, nextSingleInstrumentationID) {
  return setCookie(getSingleInstrumentationIDCookieName(uniqueCookieFeatureName), nextSingleInstrumentationID, {
    expires: 7,
    domain: location.hostname,
    sameSite: 'strict'
  });
};
export var readSingleInstrumentationIDCookie = function readSingleInstrumentationIDCookie(uniqueCookieFeatureName) {
  return getCookie(getSingleInstrumentationIDCookieName(uniqueCookieFeatureName)) || SINGLE_INSTRUMENTATION_ID_IS_NOT_SET;
};